export default __webpack_public_path__ + "static/media/office1-before2-1024w.02024748.webp";